import { useTranslation } from "react-i18next";
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { DateTimePicker } from "@/components/ui/datetime-picker";
import { Label } from "@/components/ui/label";

type Props = {
	sn: string | null;
	type: "mqtt" | "advant" | null;
	at: Date | null;
	minDate: Date | null;
	isPending: boolean;
	isPastDate: boolean;
	canSubmit: boolean;
	onAtChange: (date: Date | null) => void;
	onOpenChange: (open: boolean) => void;
	onConfirm: () => void;
};

export function DmSendReadingDialog({
	sn,
	type,
	at,
	minDate,
	isPending,
	isPastDate,
	canSubmit,
	onAtChange,
	onOpenChange,
	onConfirm,
}: Props) {
	const { t } = useTranslation();
	const isAdvant = type === "advant";

	return (
		<AlertDialog
			open={!!sn}
			onOpenChange={(open) => {
				if (!open && !isPending) onOpenChange(false);
			}}
		>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>
						{t(
							isAdvant
								? "mqttSources.sendReadingNow"
								: "mqttSources.sendReadingTitle",
						)}
					</AlertDialogTitle>
					<AlertDialogDescription>
						{t(
							isAdvant
								? "mqttSources.sendReadingNowDescription"
								: "mqttSources.sendReadingDescription",
							{ sn },
						)}
					</AlertDialogDescription>
				</AlertDialogHeader>
				{isAdvant ? null : (
					<div className="flex flex-col gap-1.5">
						<Label htmlFor="send-reading-start-time">
							{t("mqttSources.sendReadingStartTime")}
						</Label>
						<DateTimePicker
							id="send-reading-start-time"
							value={at}
							onChange={onAtChange}
							minDate={minDate ?? undefined}
							aria-invalid={isPastDate}
						/>
						{isPastDate ? (
							<p className="text-destructive text-xs">
								{t("datetimePicker.pastDateError")}
							</p>
						) : null}
					</div>
				)}
				<AlertDialogFooter>
					<AlertDialogCancel disabled={isPending}>
						{t("mqttSources.cancel")}
					</AlertDialogCancel>
					<AlertDialogAction
						disabled={!canSubmit || isPending}
						onClick={(e) => {
							e.preventDefault();
							onConfirm();
						}}
					>
						{t("mqttSources.sendReadingConfirm")}
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
}
